import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { MdOutlineClose } from 'react-icons/md';
import OtpInput from 'react-otp-input';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { resendOtp, sendOtp, submitEnquiry, verifyOtp } from '../../redux/actions/AuthActions';
import { fetchSubCategories } from '../../redux/actions/ProjectReportAction';
import swal from 'sweetalert2';

const CmLeadModal = ({ isModalOpen, setIsModalOpen, leadtype }) => {
    const [formData, setFormData] = useState({
        name: '',
        password: '',
        email: '',
        mobile: '',
        type: leadtype,
        industry: '',
        sector: '',
    });
    const [otp, setOtp] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [industries, setIndustries] = useState([]);
    const [errors, setErrors] = useState({});

    const dispatch = useDispatch();
    const {  subcategory } = useSelector((state) => state.projectReportReducer);
    const { AuthReducer: { otpLoading, otpVerifiedStatus, enquiryStatus  , errors:reduxerr} } = useSelector((state) => state);

    useEffect(() => {
        dispatch(fetchSubCategories(5));
    }, []);

    useEffect(() => {
        if (formData.sector == 3267) {
            axios(`/api/cm-yuva/franchise-sector`)
                .then((res) => setIndustries(res.data?.sector))
                .catch((err) => console.log(err));
        } else {
            axios(`/api/cm-yuva/get-sub-sub-categories/${formData.sector}`)
                .then((res) => setIndustries(res.data?.projectIndustry))
                .catch((err) => console.log(err));
        }
    }, [formData.sector]);



  const notify = (message, type) => {
          swal.fire({
              show: true,
              //    title: "Well done!",
              text: message,
              icon: type,
              showConfirmButton: false,
              timer: 1500,
          });
      };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const validateMobile = (mobile) => {
        if (!mobile) return 'Mobile number is required.';
        if (mobile.length < 10 || mobile.length > 13) return 'Please enter a valid mobile number.';
        return '';
    };

    const handleSendOtp = () => {
        const mobileError = validateMobile(formData.mobile);
        if (mobileError) {
            setErrors({ mobile: mobileError });
            return;
        }
        dispatch(sendOtp(formData.mobile));
        setIsOtpSent(true);
        notify('OTP Sent Successfully', 'success');
    };

    const handleOTPChange = (value) => {
        setOtp(value);
        if (value.length === 4) dispatch(verifyOtp(formData.mobile, value));
    };

    const handleResendOtp = () => {
        notify('OTP Resent Successfully', 'success');
        dispatch(resendOtp(formData.mobile));
    };

    const handleVerifyOtp = () => {
        if (otp.length === 4 && !isNaN(otp)) {
            dispatch(verifyOtp(formData.mobile, otp));
            if (!otpVerifiedStatus) {
                notify('Invalid OTP', 'error');
                setErrors({ otp: 'Enter valid OTP' });
            } else {
                setErrors({ otp: '' });
            }
        } else {
            notify('Invalid OTP', 'error');
            setErrors({ otp: 'Enter valid OTP' });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const newErrors = {};

        if (!formData.name) newErrors.name = 'Name is required';
        if (!formData.email) newErrors.email = 'Email is required';
        if (!formData.sector) newErrors.sector = 'Sector is required';
        if (!formData.industry) newErrors.industry = 'Industry is required';

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        dispatch(submitEnquiry(formData));
        
    };
useEffect(()=>{
    if (enquiryStatus?.success) {
        notify(enquiryStatus.message, 'success');
        setIsModalOpen(false);
        setIsOtpSent(false);
        setErrors({});
        setFormData({
            name: '',
            password: '',
            email: '',
            mobile: '',
            type: '',
            industry: '',
            sector: '',
        });
    }
    dispatch({type:"RESET_DEFAULT"});
},[enquiryStatus])
    useEffect(() => {
        const inputs = document.querySelectorAll('input[type="number"]');
        const handleWheel = (e) => {
            e.preventDefault();
            e.target.blur();
        };

        inputs.forEach((input) => input.addEventListener('wheel', handleWheel, { passive: false }));
        return () => {
            inputs.forEach((input) => input.removeEventListener('wheel', handleWheel));
        };
    }, []);

    return (

        <Modal show={isModalOpen} onHide={() => setIsModalOpen(false)} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>Register</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label>Mobile<span className="text-danger">*</span></label>
                            <input
                                type="number"
                                className="form-control"
                                name="mobile"
                                value={formData.mobile}
                                onChange={(e) => {
                                    if (e.target.value.length <= 10) handleChange(e);
                                }}
                            />
                            {errors.mobile && <div className="text-danger">{errors.mobile}</div>}
                        </div>
                        <div className="col-md-6 d-flex align-items-end">
                            {!otpVerifiedStatus && !isOtpSent && (
                                <Button variant="primary" className='smp-round-btn ro-btn-theme' onClick={handleSendOtp}>
                                    Send OTP
                                </Button>
                            )}
                            {!otpVerifiedStatus && isOtpSent && (
                                <Button variant="primary" className='smp-round-btn ro-btn-theme' onClick={handleVerifyOtp}>
                                    Verify OTP
                                </Button>
                            )}
                        </div>
                        {isOtpSent && !otpVerifiedStatus && (
                            <div className="col-12 mt-3">
                                <label>Enter OTP<span className="text-danger">*</span></label>
                                <OtpInput
                                    value={otp}
                                    numInputs={4}
                                    separator={<span className="me-2 ms-2">*</span>}
                                    onChange={handleOTPChange}
                                    inputStyle={{
                                        width: "100%",
                                        borderRadius: "6px",
                                        marginLeft:"10px",
                                        marginRight:"10px",
                                        border: "1px solid #000",
                                        height: "38px",
                                    }}
                                    renderInput={(props) => <input {...props} />}

                                />
                                {errors.otp && <div className="text-danger mt-2">{errors.otp}</div>}
                                <div>
                                    <a role="button" onClick={handleResendOtp} style={{ cursor: 'pointer' }}>
                                        {otpLoading ? 'Loading...' : 'Resend OTP'}
                                    </a>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <label>Name<span className="text-danger">*</span></label>
                            <input
                                type="text"
                                className="form-control"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                            />
                            {errors.name && <div className="text-danger">{errors.name}</div>}
                        </div>
                        <div className="col-md-6">
                            <label>Email<span className="text-danger">*</span></label>
                            <input
                                type="email"
                                className="form-control"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                            {errors.email && <div className="text-danger">{errors.email}</div>}
                        </div>
                    </div>

                    <div className="row mt-3">
                        <div className="col-md-6">
                            <label>Sector<span className="text-danger">*</span></label>
                            <select
                                className={`form-control ${errors.sector ? 'is-invalid' : ''}`}
                                name="sector"
                                value={formData.sector}
                                onChange={handleChange}
                            >
                                <option value="">Select Sector</option>
                                {subcategory?.map?.((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            {errors.sector && <div className="text-danger">{errors.sector}</div>}
                        </div>
                        <div className="col-md-6">
                            <label>Industry<span className="text-danger">*</span></label>
                            <select
                                className={`form-control ${errors.industry ? 'is-invalid' : ''}`}
                                name="industry"
                                value={formData.industry}
                                onChange={handleChange}
                            >
                                <option value="">Select Industry</option>
                                {industries?.map?.((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.name}
                                    </option>
                                ))}
                            </select>
                            {errors.industry && <div className="text-danger">{errors.industry}</div>}
                        </div>
                    </div>
                </form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" className='smp-round-btn' onClick={() => setIsModalOpen(false)}>
                    Close
                </Button>
                <Button variant="primary" className='smp-round-btn ro-btn-theme' onClick={handleSubmit} disabled={!otpVerifiedStatus}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CmLeadModal;
